import React from "react";
import { GlobeIcon } from "lucide-react";
import { modules } from "../data/content";
const stats = [{
  value: "189",
  label: "páginas"
}, {
  value: "13",
  label: "módulos"
}, {
  value: "10",
  label: "archivos PDF"
}];
export function Breakdown() {
  return <section className="bg-white py-20 md:py-28" aria-labelledby="breakdown-title" data-id="element-62" data-mp="13o44ko9w2wf2">
      <div className="mx-auto grid max-w-6xl gap-14 px-5 md:px-8 lg:grid-cols-[1fr_1.15fr] lg:gap-20" data-id="element-63" data-mp="18mx8pq3adb2k">
        <div data-id="element-64" data-mp="ttvgqdvszrn8">
          <h2 id="breakdown-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-65" data-mp="yqu7qnk67ih7">
            ¿Qué incluye el producto?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-66" data-mp="ppvztu6m2qtc">
            Una guía completa de 189 páginas, organizada en 13 módulos.
          </p>

          <dl className="mt-10 grid grid-cols-3 border-y border-line" data-id="element-67" data-mp="2f5vhjzoapokl">
            {stats.map((s, i) => <div key={s.label} className={`py-6 ${i > 0 ? "border-l border-line pl-5" : ""}`} data-id="element-68" data-mp="2k243px0wui19" data-mpi={i}>
                <dt className="sr-only" data-id="element-69" data-mp="37aqx2m3sqcb7">{s.label}</dt>
                <dd data-id="element-70" data-mp="33brwtet0f3q3">
                  <span className="block font-display text-4xl font-semibold text-ink md:text-5xl" data-id="element-71" data-mp="33a73ttmcfsuc">
                    {s.value}
                  </span>
                  <span className="mt-1 block text-sm font-medium text-muted" data-id="element-72" data-mp="3c3k4xiuka0ri">{s.label}</span>
                </dd>
              </div>)}
          </dl>

          <div className="mt-8 flex items-start gap-3 rounded-2xl bg-mint-soft p-5" data-id="element-73" data-mp="2odzjmtaxqrf2">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink" aria-hidden="true" data-id="element-74" data-mp="2kdp2qllluglf" />
            <p className="text-sm leading-relaxed text-ink" data-id="element-75" data-mp="2ycosxxorn3jp">
              Con ejemplos económicos principalmente en pesos argentinos (ARS) y referencias complementarias para
              Estados Unidos y Brasil.
            </p>
          </div>
        </div>

        <div data-id="element-76" data-mp="8mtt2ncasthw">
          <h3 className="text-sm font-bold text-muted" data-id="element-77" data-mp="8n3ctt6r24f5">Vas a encontrar contenido sobre:</h3>
          <ol className="mt-4" data-id="element-78" data-mp="gnsr5m4e0234">
            {modules.map((m, i) => <li key={m} className="flex items-center gap-5 border-b border-line py-5 first:border-t" data-id="element-79" data-mp="gplyl3mtqqc6" data-mpi={i}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sun font-display text-sm font-semibold text-ink" data-id="element-80" data-mp="poz8tyirvixy">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-lg font-semibold text-ink" data-id="element-81" data-mp="3t6hjsetud62l">{m}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}